// extracted by mini-css-extract-plugin
module.exports = {"iframes_container":"MapStore_iframes_container__1kqHJ","iframes_smaller_imgs":"MapStore_iframes_smaller_imgs__38EZH"};